
import React, { useEffect, useState } from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const [stars, setStars] = useState<Array<{ id: number; x: number; y: number; opacity: number; symbol: string }>>([]);

  useEffect(() => {
    // Generate random star positions with 80% stars and 20% dollar signs
    const generateStars = () => {
      const newStars = [];
      for (let i = 0; i < 50; i++) {
        newStars.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          opacity: Math.random(),
          symbol: Math.random() < 0.8 ? '★' : '$', // 80% stars, 20% dollar signs
        });
      }
      setStars(newStars);
    };

    generateStars();

    // Animate stars
    const interval = setInterval(() => {
      setStars(prevStars =>
        prevStars.map(star => ({
          ...star,
          opacity: Math.random(),
        }))
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const scrollToConsultation = () => {
    const element = document.getElementById('consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
      }}
    >
      {/* Animated Stars Background */}
      <div className="absolute inset-0">
        {stars.map(star => (
          <div
            key={star.id}
            className="absolute text-yellow-400 text-lg transition-opacity duration-2000"
            style={{
              left: `${star.x}%`,
              top: `${star.y}%`,
              opacity: star.opacity,
            }}
          >
            {star.symbol}
          </div>
        ))}
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              <span className="text-yellow-400" style={{ fontFamily: '"Inter", sans-serif' }}>Ad Astra</span><br />
              <span className="text-yellow-400">Fractional CFO</span>
            </h1>
            <p className="text-xl lg:text-2xl text-gray-300 mb-8 leading-relaxed">
              <strong>Profitability. Control. Clarity.</strong><br />
              We help private practice owners <strong>make more money</strong>, <strong>save more money</strong>, and <strong>understand their money</strong> through expert strategic CFO guidance that truly gets what you're going through.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={scrollToConsultation}
                size="lg"
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
              >
                <i className="ri-calendar-line mr-2"></i>
                Book Your Free Consultation
              </Button>
              <Button 
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-gray-900"
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Learn More
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/5d4a5a45124bbd969ca36209058115e0.jpg"
              alt="Private practice owner achieving financial success through expert CFO guidance"
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};
